import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState, } from "react";
import { caretAfterDigits, completeTime, digitsBefore, formatTypedTime, segmentAt, segmentRange, stepTime, toTimeValue, } from "./time-input-format";
export const DoraTimeInput = (props) => {
    const { value, onChange, disabled, className, style } = props;
    const inputRef = useRef(null);
    const [text, setText] = useState(value || "");
    const pendingSelection = useRef(null);
    useEffect(() => {
        if ((value || "") !== toTimeValue(text)) {
            setText(value || "");
        }
    }, [value]);
    useLayoutEffect(() => {
        if (pendingSelection.current && inputRef.current) {
            inputRef.current.setSelectionRange(...pendingSelection.current);
            pendingSelection.current = null;
        }
    });
    const update = (next, selection) => {
        pendingSelection.current = selection;
        setText(next);
        const nextValue = toTimeValue(next);
        if (nextValue !== (value || "")) {
            onChange(nextValue);
        }
    };
    const selectSegment = (segment) => inputRef.current?.setSelectionRange(...segmentRange(segment));
    const onTextChange = (e) => {
        const raw = e.target.value;
        const caret = e.target.selectionStart ?? raw.length;
        const formatted = formatTypedTime(raw);
        if (formatted === null) {
            const back = Math.max(caret - 1, 0);
            e.target.value = text;
            e.target.setSelectionRange(back, back);
            return;
        }
        const addedDigits = digitsBefore(formatted, formatted.length) - digitsBefore(raw, raw.length);
        const pos = caretAfterDigits(formatted, digitsBefore(raw, caret) + addedDigits);
        const inserting = e.nativeEvent.inputType?.startsWith("insert");
        if (inserting && pos === 2 && /^\d{2}:\d{2}$/.test(formatted)) {
            update(formatted, segmentRange("minute"));
        }
        else {
            update(formatted, [pos, pos]);
        }
    };
    const onKeyDown = (e) => {
        const caret = e.currentTarget.selectionStart ?? 0;
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault();
            const segment = segmentAt(text, caret);
            update(stepTime(text, segment, e.key === "ArrowUp" ? 1 : -1), segmentRange(segment));
            return;
        }
        if (e.key === "Tab" && toTimeValue(text) !== "") {
            const segment = segmentAt(text, caret);
            if (!e.shiftKey && segment === "hour") {
                e.preventDefault();
                selectSegment("minute");
            }
            else if (e.shiftKey && segment === "minute") {
                e.preventDefault();
                selectSegment("hour");
            }
        }
    };
    const onFocus = (e) => {
        if (toTimeValue(text) !== "") {
            e.currentTarget.setSelectionRange(...segmentRange("hour"));
        }
    };
    const onMouseUp = (e) => {
        const { selectionStart, selectionEnd } = e.currentTarget;
        if (toTimeValue(text) !== "" && selectionStart === selectionEnd) {
            selectSegment(segmentAt(text, selectionStart ?? 0));
        }
    };
    const onBlur = () => {
        const completed = completeTime(text);
        if (completed !== text) {
            setText(completed);
            const completedValue = toTimeValue(completed);
            if (completedValue !== (value || "")) {
                onChange(completedValue);
            }
        }
    };
    return (_jsx("input", { ref: inputRef, type: "text", inputMode: "numeric", autoComplete: "off", placeholder: "--:--", maxLength: 5, value: text, disabled: disabled, onChange: onTextChange, onKeyDown: onKeyDown, onFocus: onFocus, onMouseUp: onMouseUp, onBlur: onBlur, className: className, style: style, "aria-label": props["aria-label"] }));
};
//# sourceMappingURL=DoraTimeInput.js.map